import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";
import { useFormik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useBeforeUnload } from "../../lib/useBeforeUnload";
import useCustomToast from "../../lib/useCustomToast";
import ButtonLogin from "../button/ButtonLogin";
import { ButtonPrimary } from "../button/ButtonPrimary";

interface Props extends StackProps {
  url: string;
}

const initialValues = {
  email: undefined,
};

export const RegisterEmailForm = ({ url, ...props }: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useCustomToast();
  const navigate = useNavigate();
  useBeforeUnload();

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: yup.object().shape({
      email: yup
        .string()
        .required("Email harus diisi")
        .email("Format email harus benar")
        .max(255, "Email tidak boleh lebih dari 255 karakter"),
    }),
    onSubmit: (values) => {
      setLoading(true);

      axios
        .post(
          `${process.env.REACT_APP_WEB_API_BASE_URL}/v1/auth/buyer/register`,
          {
            email: values.email,
          }
        )
        .then((res) => {
          values.email && localStorage.setItem("registeredEmail", values.email);
          toast({
            title:
              "Periksa kotak masuk anda kami telah mengirim Kode OTP ke email anda",
            status: "success",
          });
          navigate("?step=otp");
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <VStack p={10} {...props}>
      <Text
        fontWeight={"semibold"}
        fontSize={[18, null, 20]}
        textAlign={"center"}
      >
        Daftar sekali untuk akses 3 tipe akun
      </Text>

      <Text
        variant={"secondary"}
        textAlign={"center"}
        fontSize={[12, null, 14]}
      >
        Dengan sekali mendaftar anda sudah bisa mengakses akun pembeli,
        reseller, dan supplier
      </Text>

      <form
        id="registerEmailForm"
        onSubmit={formik.handleSubmit}
        style={{ width: "100%", marginTop: "40px" }}
      >
        <VStack w={"100%"} gap={6}>
          <FormControl
            isInvalid={
              formik.errors.email && formik.touched.email ? true : false
            }
          >
            <FormLabel htmlFor="email">Email</FormLabel>
            <Input
              name="email"
              type="text"
              placeholder="email@gmail.com"
              onChange={formik.handleChange}
              value={formik.values.email || ""}
            />
            <FormErrorMessage>{formik.errors.email}</FormErrorMessage>
          </FormControl>

          <ButtonPrimary
            form="registerEmailForm"
            isLoading={loading}
            loadingText="Loading"
            spinnerPlacement="start"
            type="submit"
            w={"100%"}
          >
            Daftar
          </ButtonPrimary>

          <HStack mt={4} gap={1}>
            <Text textStyle={"b-reg"}>Sudah mempunyai akun? </Text>

            <ButtonLogin
              fontSize={[12, null, 14]}
              fontWeight={"semibold"}
              size={["xs", null, "sm"]}
              variant="ghost"
            />
          </HStack>
        </VStack>
      </form>
    </VStack>
  );
};
